module.exports = __webpack_public_path__ + "static/img/pin-multi-active-irregular.1e9feda.svg";